<template>
    <MainPage isMyAccount>
        <template v-slot:header>
            <div class="header-title">
                {{ lbl.my_account }}
            </div>
        </template> 
        <div class="my-account-card">
            <div
                class="profile-image"
                :style="{'background-image': `url(${profileImagePath})`}"
            ></div>
            <div>
                <div class="header-txt">{{profile.name}}</div>
                <div class="d-flex">
                    <img class="img-size" src="@/assets/icon/ic-phone.png" />
                    <div class="sub-header-txt">{{profile.contactNumber}}</div>
                </div>
                <div class="d-flex">
                    <img class="img-size" src="@/assets/icon/ic-mail.png" />
                    <div class="sub-header-txt">{{profile.email}}</div>
                </div>
            </div>
        </div>
        <div>
            <SideMenuMobile></SideMenuMobile>
        </div>

        <!-- <div class="my-account-page">
            <div class="header-layout">
                <div class="header-bar">
                    <div class="header-title">
                        <img class="icon-back" src="@/assets/icon/icon-back.svg" @click="clickBack()">
                        <div class="text">My Account</div>
                        <div class="mock-div"></div>
                    </div>
                    <div class="profile-img-wrapper">
                        <ProfilePicture
                            ref="profile-picture"
                        ></ProfilePicture>
                        <div class="icon-camera" @click="clickSelectImageProfile()">
                            <img src="@/assets/icon/ic-camera.svg" alt="">
                        </div>
                    </div>
                </div>
                <div class="header-text">{{profile.name}}</div>
                <div class="sub-header-text">{{profile.membershipUserName}}</div>
            </div>
            <div class="content-layout">
                <div>
                    <SideMenuMobile></SideMenuMobile>
                </div>
            </div>
        </div> -->
    </MainPage>
</template>

<script>
// components
import SideMenuMobile from '../SideMenu/SideMenuMobile.vue';
import MainPage from './MainPage.vue';
// mixin
import AccountMixin from '@/mixin/AccountMixin'
import LocaleMixin from '@/mixin/LocaleMixin';
// helper
import Account from '@/helper/AccountHelper.js';
// config
import ConfigManager from '@/config/ConfigManager';
export default {
    name: 'MyAccount',
    mixins: [AccountMixin, LocaleMixin],
    components: {
        SideMenuMobile,
        MainPage
    },
    data: function() {
        return {
            profileImagePath: ''
        }
    },
    created: function() {
        console.log(this.profile)
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            if (status) {
                this.profileImagePath = this.getUrlProfileImage();
            }
        });
    },
    methods: {
        clickBack: function() {
            this.$router.back()
        },
        getUrlProfileImage: function() {
            const userId = Account.getCacheUser().userId;
            const token = Account.getToken();
            const currentTime = new Date().getTime();
            var imageUrl = ConfigManager.getApiUrl() + `/profile/${userId}/picture?type=large&token=${token}&time=${currentTime}`;
            return imageUrl;
        },
    }
}
</script>

<style lang="scss" scoped>
    @import '@/style/base/base.scss';
    @import './MyAccount.scss';
</style>
